import { HardwareStatusMap } from '@/types/hardware';
const state = {
    status: new HardwareStatusMap(),
    config: {}
};
export default state;
